import { Controller } from "@hotwired/stimulus"
import "./diet.css"

export default class extends Controller {}
